import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import GameController from './components/game-controller/game_controller';

function App() {
  return (
    <div className="App">
      <GameController />      
    </div>
  );
}

export default App;
